"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _constants = require("../constants");
var _Chip = _interopRequireDefault(require("../Chip"));
var _Stack = _interopRequireDefault(require("../Stack"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function Chips({
  spaceSize,
  chipProps,
  children,
  dataTestId
}) {
  return /*#__PURE__*/_react.default.createElement(_Stack.default, {
    horizontal: true,
    size: spaceSize,
    dataTestId: dataTestId ? `${dataTestId}-container` : undefined
  }, _react.Children.map(children, (child, index) => /*#__PURE__*/_react.default.createElement(_Chip.default, (0, _extends2.default)({
    unspaced: true,
    unbordered: true,
    label: child,
    size: "small",
    fontWeight: "normal",
    closeIcon: false,
    type: "rectangular",
    color: _Chip.default.COLOR.accent,
    dataTestId: dataTestId && `${dataTestId}-chip-${index}`
  }, chipProps))));
}
Chips.SIZE = _constants.SPACE_SIZE;
Chips.defaultProps = {
  spaceSize: Chips.SIZE.xsmall
};
var _default = exports.default = Chips;